// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","873":"LazyIdentificationForm"}[chunkId] + "." + {"99":"04337936daf6a2e45dd7","873":"5d7c295c674bb0d199ea"}[chunkId] + ".js";
};